<div class="footer">
  <span class="copyright">Copyright © 2025 AbbVie Inc. North Chicago, Illinois, U.S.A. <span class="version">({{version}}.&nbsp;{{environment}})</span></span>
  <div>
    <!--<a href="mailto:AccessHub@abbvie.com"><i></i>Questions, Comments or Feedback?</a>-->
  </div>
</div>
